import {
    Popover,
    PopoverTrigger,
    Button,
    PopoverContent,
    PopoverArrow,
    PopoverCloseButton,
    PopoverBody,
    SimpleGrid,
} from "@chakra-ui/react";
import { useState } from "react";

export default function ColorPicker({ color, onColorChanged }) {
    const [internalColor, setColor] = useState(color);

    const colors = [
        "#718096",
        "#e43e3e",
        "#2d3748",
        "#3181ce",
        "#2a4365",
        "#d69e2e",
        "#dd6a1f",
        "#7f5bd5",
        "#d53f8c",
        "#088F8F"
    ];

    return <Popover variant="picker">
        <PopoverTrigger>
            <Button
                aria-label={internalColor}
                background={internalColor}
                height="40px"
                width="60px"
                padding={0}
                minWidth="unset"
                borderRadius={3}
            ></Button>
        </PopoverTrigger>
        <PopoverContent width="170px">
            <PopoverArrow bg={internalColor} />
            <PopoverCloseButton color="white" />

            <PopoverBody height="70px">
                <SimpleGrid columns={5} spacing={2}>
                    {colors.map((c) => (
                        <Button
                            key={c}
                            aria-label={c}
                            background={c}
                            height="22px"
                            width="22px"
                            padding={0}
                            minWidth="unset"
                            borderRadius={3}
                            _hover={{ background: c }}
                            onClick={() => {
                                setColor(c);
                                if (onColorChanged) {
                                    onColorChanged(c)
                                }
                            }}
                        ></Button>
                    ))}
                </SimpleGrid>
            </PopoverBody>
        </PopoverContent>
    </Popover>
}